import { Action } from "@ngrx/store";

//STATE
export interface UIState {
  mainbarOpened: boolean;
  mainbarMode: string;
}
export const UI_STATE_INIT: UIState = {
  mainbarOpened: false,
  mainbarMode: 'push',
}

//CONSTANTS
export const UI_OPEN_MAINBAR_ACTION = '[UI] OPEN_MAINBAR_ACTION';
export const UI_CLOSE_MAINBAR_ACTION = '[UI] CLOSE_MAINBAR_ACTION';
export const UI_TOGGLE_MAINBAR_ACTION = '[UI] TOGGLE_MAINBAR_ACTION';
export const UI_TOGGLE_MAINBAR_MODE_ACTION = '[UI] TOGGLE_MAINBAR_MODE_ACTION';

//ACTIONS
export function uiOpenMainBarAction(): Action {
  return { type: UI_OPEN_MAINBAR_ACTION }
}
export function uiCloseMainBarAction(): Action {
  return { type: UI_CLOSE_MAINBAR_ACTION }
}
export function uiToggleMainBarAction(): Action {
  return { type: UI_TOGGLE_MAINBAR_ACTION }
}
export function uiToggleMainBarModeAction(): Action {
  return { type: UI_TOGGLE_MAINBAR_MODE_ACTION }
}

//REDUCER
export function uiReducer(state: UIState = UI_STATE_INIT, action: Action): UIState {
  switch (action.type) {
    case UI_OPEN_MAINBAR_ACTION:
      return Object.assign({}, state, { mainbarOpened: true });
    case UI_CLOSE_MAINBAR_ACTION:
      return Object.assign({}, state, { mainbarOpened: false });
    case UI_TOGGLE_MAINBAR_ACTION:
      return Object.assign({}, state, { mainbarOpened: !state.mainbarOpened });
    case UI_TOGGLE_MAINBAR_MODE_ACTION:
      return Object.assign({}, state, { mainbarMode: state.mainbarMode === 'push' ? 'over' : 'push' });
    default:
      return state;
  }
}

//EFFECTS


// WEBPACK FOOTER //
// ./src/app/store/ui/index.ts